const variants = {
  metric: {
    bg: 'metricBg',
    boxShadow: "0 0 2px 2px #53c",
    borderRadius: "4px",
    width: "3.5em",
    px: 1,
    textAlign: "right",
    display: "inline-block",
    marginBottom: 1,
  },
}

export const text = { variants }